import { LoaderCircle } from 'lucide-react';

const Spinner = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <LoaderCircle
        aria-label="Loading..."
        className="animate-spin"
        role="img"
        size={24}
        strokeWidth={1.75}
      />
    </div>
  );
};

export default Spinner;
